var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pm-progress"},[_c('span',{staticClass:"pm-progress__bar",class:_vm.tone ? 'pm-progress__bar--' + _vm.tone : ''},[_c('i',{style:({width: _vm.width + '%'})})]),_c('span',[_vm._v(_vm._s(_vm.label || _vm.width + '%'))])])}
var staticRenderFns = []

export { render, staticRenderFns }